import { render, staticRenderFns } from "./TaskVersionCardContent.vue?vue&type=template&id=2cee35c8&"
import script from "./TaskVersionCardContent.vue?vue&type=script&lang=ts&"
export * from "./TaskVersionCardContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports